import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// This is the correct way to start an application that uses NgModules.
// It tells Angular to load your AppModule, which contains all your
// imports, declarations, and providers.
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
